var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect19, _rect20, _g, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0340_web_developer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    "data-imageid": "coding-5-61",
    imageName: "Coding 5",
    className: "illustrations_image",
    style: {
      width: 158
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_coding-5-61{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3.87px;}.cls-2_coding-5-61{fill:url(#linear-gradient);}.cls-2_coding-5-61,.cls-3_coding-5-61,.cls-4_coding-5-61,.cls-5_coding-5-61,.cls-6_coding-5-61,.cls-7_coding-5-61,.cls-8_coding-5-61,.cls-9_coding-5-61,.cls-10_coding-5-61,.cls-11_coding-5-61,.cls-12_coding-5-61,.cls-13_coding-5-61,.cls-14_coding-5-61,.cls-15_coding-5-61{stroke-width:0px;}.cls-3_coding-5-61{opacity:.18;}.cls-3_coding-5-61,.cls-4_coding-5-61,.cls-11_coding-5-61{isolation:isolate;}.cls-3_coding-5-61,.cls-11_coding-5-61,.cls-15_coding-5-61{fill:#68e1fd;}.cls-4_coding-5-61{opacity:.51;}.cls-4_coding-5-61,.cls-13_coding-5-61{fill:#fff;}.cls-5_coding-5-61{fill:url(#linear-gradient-4-coding-5-61);}.cls-6_coding-5-61{fill:url(#linear-gradient-2-coding-5-61);}.cls-7_coding-5-61{fill:url(#linear-gradient-3-coding-5-61);}.cls-8_coding-5-61{fill:url(#linear-gradient-7-coding-5-61);}.cls-9_coding-5-61{fill:url(#linear-gradient-5-coding-5-61);}.cls-10_coding-5-61{fill:url(#linear-gradient-6-coding-5-61);}.cls-11_coding-5-61{opacity:.48;}.cls-12_coding-5-61{fill:#3f3d56;}.cls-14_coding-5-61{fill:#ffb4a3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-coding-5-61",
    x1: 216.24,
    y1: 1746.9,
    x2: 275.13,
    y2: 1724.45,
    gradientTransform: "translate(-35.89 2035.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#000",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-coding-5-61",
    x1: 186.35,
    y1: 1681.95,
    x2: 168.48,
    y2: 1789.74,
    xlinkHref: "#linear-gradient-coding-5-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-coding-5-61",
    x1: 192.69,
    y1: 1687.96,
    x2: 222.13,
    y2: 1754.21,
    xlinkHref: "#linear-gradient-coding-5-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4-coding-5-61",
    x1: 344.29,
    y1: 1753.54,
    x2: 293.82,
    y2: 1583.98,
    gradientTransform: "translate(-31 2048.68) scale(1 -1)",
    xlinkHref: "#linear-gradient-coding-5-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5-coding-5-61",
    x1: 136.07,
    y1: 1745.5,
    x2: 184.96,
    y2: 1513.62,
    gradientTransform: "translate(-31 2048.68) scale(1 -1)",
    xlinkHref: "#linear-gradient-coding-5-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6-coding-5-61",
    x1: 345.72,
    y1: 1691.33,
    x2: 346.41,
    y2: 1723.23,
    gradientTransform: "translate(-35.89 2035.89) scale(1 -1)",
    xlinkHref: "#linear-gradient-coding-5-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7-coding-5-61",
    x1: 395.85,
    y1: 1671.62,
    x2: 400.58,
    y2: 1791.5,
    xlinkHref: "#linear-gradient-coding-5-61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "background_coding-5-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11_coding-5-61 targetColor",
    x: 47.52,
    y: 59.83,
    width: 434.1,
    height: 278.05,
    rx: 10.49,
    ry: 10.49,
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3_coding-5-61 targetColor",
    d: "M473.03,358.17c-.32,9.11-2.4,18.38-7.5,25.92-6.42,9.5-16.85,15.39-26.96,20.92l-28.64,15.76c-12.55,6.91-25.78,13.99-40.09,14.19-10.13.15-19.92-3.19-29.66-5.99-45.48-13.13-93.39-14.97-140.41-11.65-24.08,1.7-48.05,4.69-71.91,8.29-19.09,2.84-42,12.27-59.22,1.1-18.75-12.19-30.26-31.92-40.85-51.09-9.22-16.63-18.58-33.67-21.62-52.43-4.69-28.99,6.54-58.77,24.11-82.33,5.28-7.04,11.05-13.69,17.26-19.92v106.45c0,5.8,4.69,10.52,10.49,10.55h413.11c1.47,6.64,2.11,13.43,1.91,20.23Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3_coding-5-61 targetColor",
    d: "M318.68,59.84h-110.46c4.16-3.16,8.67-5.82,13.45-7.92,8.73-3.81,18.25-5.51,27.74-6.19,23.88-1.72,47.84,3.55,69.26,14.11Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3_coding-5-61 targetColor",
    d: "M481.61,70.33v51.33H47.52v-51.33c0-5.8,4.69-10.52,10.49-10.55h413.11c5.8.03,10.49,4.75,10.49,10.55Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_coding-5-61",
    x: 254.74,
    y: 226.6,
    width: 162.43,
    height: 9.14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 254.74,
    y: 210.95,
    width: 115.47,
    height: 9.14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 386,
    y: 210.95,
    width: 77.3,
    height: 9.14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 344.18,
    y: 153.08,
    width: 118.85,
    height: 8.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_coding-5-61",
    x: 319.29,
    y: 167.51,
    width: 127.15,
    height: 8.12
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 256.94,
    y: 153.08,
    width: 78.17,
    height: 8.12
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 291.23,
    y: 181.5,
    width: 171.8,
    height: 8.12
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_coding-5-61",
    x: 256.94,
    y: 181.5,
    width: 25.22,
    height: 8.12
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_coding-5-61",
    x: 349.63,
    y: 195.93,
    width: 113.4,
    height: 8.12
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 256.94,
    y: 195.93,
    width: 78.17,
    height: 8.12
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 256.94,
    y: 167.17,
    width: 50.27,
    height: 8.12
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 300.71,
    y: 125.74,
    width: 118.85,
    height: 8.12
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_coding-5-61",
    x: 275.82,
    y: 140.17,
    width: 127.15,
    height: 8.12
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 213.48,
    y: 125.74,
    width: 78.17,
    height: 8.12
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 299.66,
    y: 108.92,
    width: 118.85,
    height: 8.12
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 212.43,
    y: 93.66,
    width: 78.17,
    height: 8.12
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 212.43,
    y: 79.74,
    width: 78.17,
    height: 8.12
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_coding-5-61",
    x: 213.48,
    y: 139.83,
    width: 50.27,
    height: 8.12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "character_coding-5-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15_coding-5-61 targetColor",
    d: "M217.61,302.88c1.08,1.43,2.37,2.68,3.83,3.7,2.17,1.17,4.57,1.88,7.03,2.09l37.41,5.64c.37.03.73.15,1.04.35.42.46.62,1.07.55,1.69.17,7-.77,13.99-2.8,20.7-.11.55-.37,1.05-.76,1.45-.5.34-1.1.52-1.71.52-12.59,1.07-25.23.73-37.85.39-2.12.03-4.24-.2-6.31-.69-3.52-.98-6.39-3.39-9.04-5.86-5.68-5.29-28.69-26.53-30.08-29.42-1.85-4.13-3.34-8.41-4.45-12.8-1.17-4.22,7.4-4.75,7.22-9.13-.12-3.03.24-6.06,1.08-8.98.62-2.6,1.92-4.99,3.75-6.94,1.29-1.17-.7-9.12,1.08-9.21,2.06,7.03,11.39,21.1,15.45,27.12,4.51,6.72,9.37,13.19,14.57,19.38Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-61",
    d: "M217.61,302.88c1.08,1.43,2.37,2.68,3.83,3.7,2.17,1.17,4.57,1.88,7.03,2.09l37.41,5.64c.37.03.73.15,1.04.35.42.46.62,1.07.55,1.69.17,7-.77,13.99-2.8,20.7-.11.55-.37,1.05-.76,1.45-.5.34-1.1.52-1.71.52-12.59,1.07-25.23.73-37.85.39-2.12.03-4.24-.2-6.31-.69-3.52-.98-6.39-3.39-9.04-5.86-5.68-5.29-28.69-26.53-30.08-29.42-1.85-4.13-3.34-8.41-4.45-12.8-1.17-4.22,7.4-4.75,7.22-9.13-.12-3.03.24-6.06,1.08-8.98.62-2.6,1.92-4.99,3.75-6.94,1.29-1.17-.7-9.12,1.08-9.21,2.06,7.03,11.39,21.1,15.45,27.12,4.51,6.72,9.37,13.19,14.57,19.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_coding-5-61 targetColor",
    d: "M122.95,243.51c-2.52,2.25-4.87,4.67-7.03,7.27-5.18,6.36-8.63,13.93-11.84,21.48-8.54,20.09-15.99,41.57-13.77,63.29.04,1.31.4,2.58,1.03,3.73,1.01,1.29,2.43,2.21,4.02,2.59,4.11,1.31,8.51,1.37,12.89,1.41,16.89.15,33.8.3,50.68-.52,2.61-.13,5.38-.33,7.55-1.8,1.58-1.21,2.85-2.79,3.68-4.61,4.54-8.53,5.86-18.4,9.38-27.38,4.69-11.72,17.58-22.37,14.86-34.73-11.63-52.45-66.12-35.57-71.44-30.73Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_coding-5-61",
    d: "M122.95,243.51c-2.52,2.25-4.87,4.67-7.03,7.27-5.18,6.36-8.63,13.93-11.84,21.48-8.54,20.09-15.99,41.57-13.77,63.29.04,1.31.4,2.58,1.03,3.73,1.01,1.29,2.43,2.21,4.02,2.59,4.11,1.31,8.51,1.37,12.89,1.41,16.89.15,33.8.3,50.68-.52,2.61-.13,5.38-.33,7.55-1.8,1.58-1.21,2.85-2.79,3.68-4.61,4.54-8.53,5.86-18.4,9.38-27.38,4.69-11.72,17.58-22.37,14.86-34.73-11.63-52.45-66.12-35.57-71.44-30.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14_coding-5-61",
    d: "M199.27,200.07c-1.98,9.62-4.06,19.5-9.38,27.79-1.94,3.35-4.75,6.11-8.12,7.99-2.44,1.36-5.7,1.74-8.39,1.01s-4.61-3.34-7.07-.27c-1.18,1.48-1.46,3.46-1.71,5.33-.31,2.4-.62,4.8-.93,7.2-.09.72-.21,1.49-.71,2.01-.34.36-.82.54-1.29.69-3.4,1.07-7.14.54-10.45-.77s-6.28-3.35-9.21-5.37c-.91-.63-1.91-1.4-1.99-2.51-.03-.42.09-.84.2-1.25,2.6-9.49,5.07-20.8,3.35-30.56-1.39-7.87,2.37-19.14,7.89-24.8,3.27-3.35,7.15-6.04,11.44-7.92,6.39-3.05,13.51-5.19,20.5-4.08,5.63.89,10.58,4.19,13.56,9.05,3.66,5.61,3.67,9.8,2.3,16.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_coding-5-61",
    d: "M216.72,178.86c.97-8.01-3.11-15.78-10.25-19.52-3.11-1.55-6.56-2.2-9.91-3.09-7.85-2.11-15.39-5.6-23.44-6.35-8.05-.75-17.31,2.07-20.9,9.38-.66,1.34-1.3,2.95-2.74,3.3-.79.08-1.58.01-2.34-.21-5.38-.95-10.22,3.64-12.65,8.53-3.91,7.91-4.11,17.13-3.26,25.91.79,8.12,2.86,16.9,9.38,21.85.64.49,1.59.94,2.22.41.28-.3.46-.68.5-1.09.66-3.08.9-6.23.73-9.38-.13-2.34-.5-4.83.11-7.14.61-2.31,2.57-4.5,4.96-4.43,2.22,0,4,2.06,4.55,4.22.39,2.2.31,4.45-.25,6.61.35.88,1.58-.18,1.79-1.09,1.62-7.36,1.98-15.6,7.09-21.1,1.04,1.08,1.8,2.39,2.2,3.83,1.56-1.61,3.9-2.2,6.04-1.5,1.48.65,2.85,1.54,4.03,2.64,12.45,9.72,39.54,6.83,42.16-11.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_coding-5-61 targetColor",
    d: "M126.54,255.51c-3.94,2.86-5.86,7.89-5.98,12.74-.12,4.85,5.02,35.64,9.86,44.38,3.75,6.8,11.57,24.54,23.44,29.44,3.52,1.45,55.49.84,79.61-1.77-.15-5.71-.43-11.41-.81-17.12.04-.75-.19-1.49-.64-2.1-.61-.63-1.48-4.77-2.34-4.77-14.06.06-28.24,4.36-42.31,4.69-2.04.13-4.09,0-6.11-.36-1.65-.41-3.23-1.06-4.69-1.92-10.85-6.14-16.85-18.2-21.1-29.93-3.25-9.05-5.86-18.41-10.55-26.86-1.66-3.01-3.15-5.94-6.43-7.27-3.86-1.56-8.38-1.73-11.95.86Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7_coding-5-61",
    d: "M126.54,255.51c-3.94,2.86-5.86,7.89-5.98,12.74-.12,4.85,5.02,35.64,9.86,44.38,3.75,6.8,11.57,24.54,23.44,29.44,3.52,1.45,55.49.84,79.61-1.77-.15-5.71-.43-11.41-.81-17.12.04-.75-.19-1.49-.64-2.1-.61-.63-1.48-4.77-2.34-4.77-14.06.06-28.24,4.36-42.31,4.69-2.04.13-4.09,0-6.11-.36-1.65-.41-3.23-1.06-4.69-1.92-10.85-6.14-16.85-18.2-21.1-29.93-3.25-9.05-5.86-18.41-10.55-26.86-1.66-3.01-3.15-5.94-6.43-7.27-3.86-1.56-8.38-1.73-11.95.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14_coding-5-61",
    d: "M231.4,315.21c7.3-.69,15.41.94,20.04,6.62.49.52.81,1.17.91,1.88,0,.63-.2,1.25-.56,1.77-2.73,4.54-8.66,5.61-13.64,7.41-2.59.93-5.06,2.16-7.37,3.66-1.3,1.03-2.8,1.77-4.41,2.18-3.52.53-6.43-2.61-8.03-5.75-1.83-3.52-4.69-10.74-1.17-14.06,2.87-2.64,10.62-3.36,14.23-3.69Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14_coding-5-61",
    d: "M291.86,313.41c1.3.74,2.42,1.76,3.27,2.99.85,1.26.96,2.88.3,4.25-.55.83-1.31,1.51-2.19,1.97-6.48,3.86-14.43,4.55-20.99,8.2-1.35.98-2.89,1.65-4.52,1.97-1.95.04-3.8-.82-5.02-2.34-1.2-1.49-2.11-3.19-2.71-5-7.68-20.16,20.81-19.07,31.85-12.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_coding-5-61 targetColor",
    d: "M64.48,337.6h411.34c3.6,0,6.52,2.91,6.52,6.51h0c0,3.6-2.92,6.51-6.52,6.51H64.48c-3.6,0-6.52-2.91-6.52-6.51h0c0-3.6,2.92-6.51,6.52-6.51Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15_coding-5-61 targetColor",
    x: 167.69,
    y: 350.81,
    width: 232.51,
    height: 80.64,
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15_coding-5-61 targetColor",
    x: 77.95,
    y: 350.81,
    width: 91.33,
    height: 80.64,
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5_coding-5-61",
    x: 169.23,
    y: 350.81,
    width: 230.98,
    height: 80.64
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_coding-5-61",
    x: 77.95,
    y: 350.81,
    width: 91.33,
    height: 80.64
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glass_coding-5-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13_coding-5-61",
    d: "M106.14,304.41h30.37v24.94c0,4.85-3.94,8.79-8.79,8.79h-12.79c-4.85,0-8.79-3.94-8.79-8.79v-24.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1_coding-5-61",
    d: "M134.46,310.45h9.2c4.05,0,7.32,3.28,7.32,7.32v3.04c0,4.05-3.28,7.32-7.32,7.32h-9.2v-17.68h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "laptop_coding-5-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15_coding-5-61 targetColor",
    d: "M385.41,337.37h-150.53c-4.22,0-7.64-3.42-7.64-7.64h0c0-4.22,3.42-7.64,7.64-7.64h150.53c4.22,0,7.64,3.42,7.64,7.64h0c0,4.22-3.42,7.64-7.64,7.64Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_coding-5-61",
    d: "M385.41,337.37h-150.53c-4.22,0-7.64-3.42-7.64-7.64h0c0-4.22,3.42-7.64,7.64-7.64h150.53c4.22,0,7.64,3.42,7.64,7.64h0c0,4.22-3.42,7.64-7.64,7.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_coding-5-61 targetColor",
    d: "M287.08,337.4h115.52l30.47-77.27c1.37-3.49-.35-7.44-3.84-8.81-.79-.31-1.63-.47-2.47-.47h-90.65c-8.97.02-17.03,5.51-20.32,13.85l-28.7,72.7Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_coding-5-61 targetColor",
    d: "M292.95,337.48h109.72l28.94-73.4c1.31-3.31-.32-7.06-3.63-8.36-.76-.3-1.56-.45-2.37-.45h-86.09c-8.53,0-16.2,5.21-19.34,13.15l-27.22,69.06Z",
    style: {
      fill: "rgb(42, 174, 186)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8_coding-5-61",
    d: "M292.95,337.48h109.72l28.94-73.4c1.31-3.31-.32-7.06-3.63-8.36-.76-.3-1.56-.45-2.37-.45h-86.09c-8.53,0-16.2,5.21-19.34,13.15l-27.22,69.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.e32c7ea071202838db91052c1ebabbb7.svg";
export { ForwardRef as ReactComponent };